import { render, staticRenderFns } from "./ReferralCreation.vue?vue&type=template&id=4c5b6b31&scoped=true&"
import script from "./ReferralCreation.vue?vue&type=script&lang=ts&"
export * from "./ReferralCreation.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralCreation.vue?vue&type=style&index=0&id=4c5b6b31&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5b6b31",
  null
  
)

export default component.exports